import React, {useState} from 'react';
import { useKeycloak } from "@react-keycloak/web";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Collapse, Nav, Navbar, NavbarToggler, NavItem } from 'reactstrap';
import axios from 'axios';
import { setMenuSelected } from '../redux/actions/menuActions';
import { setFiltering } from '../redux/actions/filteringActions';
import URLEndPointBE from './URLEndPointBE';

function Menu() {
    const { keycloak, initialized } = useKeycloak();
    const dispatch = useDispatch();
    let selected = useSelector((state: any) => state.menuSelection.selected);
    const [isOpen, setIsOpen] = React.useState(false);

    const FilteringAllTrue = async () => {
        const _rodiny_povrchu: any = await axios
            .get(URLEndPointBE+`/dict-misc/rodiny-povrchu`)
            .catch((error) => {
              console.log("Err rodiny povrchu", error)
            });
        let _rodiny_povrchu_state = _rodiny_povrchu.data.reduce((objVals: any, v: any) => ({...objVals, [v.kod]: true}), {})
        dispatch(setFiltering({flag:"POVRCHY", filtering: _rodiny_povrchu_state}))
        dispatch(setFiltering({flag:"DOPLNKY", filtering: _rodiny_povrchu_state}))
        
        const _rodiny_vybaveni: any = await axios
            .get(URLEndPointBE+`/dict-misc/rodiny-vybaveni`)
            .catch((error) => {
                console.log("Err rodiny vybaveni", error)
            });
        let _rodiny_vybaveni_state = _rodiny_vybaveni.data.reduce((objVals: any, v: any) => ({...objVals, [v.kod]: true}), {})    
        dispatch(setFiltering({flag:"VYBAVENI", filtering: _rodiny_vybaveni_state}))
    } 

    return (<div>
        <div className="katMenu">
            <Navbar color="white" light expand="md">
                <Link onClick={()=>dispatch(setMenuSelected("null"))} className="navRemoveUnderscoreInLinkA navbarHomeBtn" to="/">
                    <span>DOMŮ</span>
                </Link>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <NavbarToggler onClick={() => { setIsOpen(!isOpen) }} />
                <Collapse isOpen={isOpen} navbar>
                    <Nav className="mr-auto" navbar>
                        <NavItem onClick={async () => {FilteringAllTrue(); /*dispatch(setMenuSelected("povrchy"))*/}} className={selected==="povrchy"?"navbarItem navbarItemSelected":"navbarItem"}>
                            <Link className="navRemoveUnderscoreInLinkA nav-link" to="/povrchy">
                                <span>POVRCHY</span>
                            </Link>
                        </NavItem>
                        <NavItem onClick={async () => {FilteringAllTrue(); /*dispatch(setMenuSelected("doplnky"))*/}} className={selected==="doplnky"?"navbarItem navbarItemSelected":"navbarItem"}>
                            <Link className="navRemoveUnderscoreInLinkA nav-link" to="/doplnky">
                                <span>DOPLŇKY</span>
                            </Link>
                        </NavItem>
                        <NavItem onClick={async () => {FilteringAllTrue(); /*dispatch(setMenuSelected("vybaveni"))*/}} className={selected==="vybaveni"?"navbarItem navbarItemSelected":"navbarItem"}>
                            <Link className="navRemoveUnderscoreInLinkA nav-link" to="/vybaveni">
                                <span>VYBAVENÍ</span>
                            </Link>
                        </NavItem>
                    </Nav>
                </Collapse>
                <span>&nbsp;</span>
                
                {/*<div>{`${!keycloak.authenticated ? 'NOT ' : ''} Authenticated`}</div>*/}
                <span>&nbsp;</span>
                <span>&nbsp;</span>
                <span>&nbsp;</span>
                <div className="hidden xl:flex items-center space-x-5">
               <div className="hover:text-gray-200">
                 {!keycloak.authenticated && (
                   <button
                     type="button"
                     className="text-blue-800"
                     onClick={() => keycloak.login()}
                   >
                     Přihlásit
                   </button>
                 )}

                 {!!keycloak.authenticated && (
                   <button
                     type="button"
                     className="text-blue-800"
                     onClick={() => keycloak.logout()}
                   >
                     Odhlásit (<b>{keycloak?.tokenParsed?.name}</b>)
                   </button>
                 )}
               </div>
               </div>
                 
                {/*<Link onClick={()=>dispatch(setMenuSelected("null"))} className="navRemoveUnderscoreInLinkA navbarHomeBtn" to="/login">
                    <span>LOGIN</span>
                </Link>*/}
            </Navbar>
        </div>
    </div>)
};
export default Menu